<template>
  <div id="rwa_launch_div" class="rwa_launch_div">

    <div class="rwa_launch_page_01">
      <Menu/>
    </div>

    <div id="rwa_launch_page_02" ref="rwa_launch_page_02" class="rwa_launch_page_02">

      <!-- 首页内容 -->
      <div class="rwa_launch_page_02_01">
        <div class="rwa_launch_page_02_011">

          <img class="rwa_launch_page_02_011_bj01" src="../../assets/images/Ellipse_bjl.png"/>
          <img class="rwa_launch_page_02_011_bj03" src="../../assets/images/Ellipse_bjr.png"/>

          <div class="rwa_launch_page_02_0111">
            <div class="rwa_launch_page_02_0111_01">
              <div class="index_page_bla_01">
                <div class="index_page_bla_011">
                  <p class="com">{{ lang('index011') }}</p>
                  <p class="com">{{ lang('index012') }}</p>

                  <p class="mob">{{ lang('index01') }}</p>
                </div>
                <div class="index_page_bla_012">
                  {{ lang('index13') }}
                </div>
                <div class="index_page_bla_013">
                </div>
              </div>
              <div class="index_page_bla_02">
                <img src="../../assets/images/image_sangd.png">
              </div>
            </div>

            <div class="rwa_launch_page_02_0111_02">
              <div class="rwa_launch_page_02_0111_021">

                <div class="launch_info_div">
                  <div class="launch_info_div01">
                    <img class="launch_info_div01_img" :src="bucoinLaunch.img"/>
                    <div class="launch_info_div01_div"></div>
                  </div>

                  <div class="launch_info_div02">
                    <div class="launch_info_div022">
                      <div class="launch_info_div0221">
                        {{ bucoinLaunch.tokenName }} <span>({{ bucoinLaunch.tokenSymbol }})</span>
                      </div>
                    </div>
                    <div class="launch_info_div023">
                      {{ bucoinLaunch.describe }}
                    </div>
                  </div>

                  <div class="launch_info_div03">
                    <div class="launch_info_div031">
                      <div class="launch_info_div0311">
                        <img class="launch_info_div0311_divimg" src="../../assets/images/bnb_logo.png"/>
                        <div class="launch_info_div03111">
                          合约: <span @click="toLink(bucoinLaunch.link)">{{ cutAccount(bucoinLaunch.ca, 5) }}</span> <img src="../../assets/images/copyl.png" @click="copyValue(bucoinLaunch.ca)"/>
                        </div>
                      </div>

                      <div class="launch_info_div0312">
                        <img src="../../assets/images/biaoqian.png"/>
                        <div class="launch_info_div03121" v-if="bucoinLaunch.link" @click="toLink(bucoinLaunch.link)">
                          已发射至Pancake Swap
                        </div>
                        <div class="launch_info_div03121" v-else>
                          未发射至Pancake Swap
                        </div>
                      </div>
                    </div>
                    <div class="launch_info_div032">
                      <div class="launch_info_div0321">
                        <img src="../../assets/images/kx.png" @click="toKline(bucoinLaunch.ca)"/>
                      </div>
                      <div class="launch_info_div0322" @click="toLink(bucoinLaunch.link)">
                        <a><img src="../../assets/images/ButtonTg.png"/></a>
                        <a><img src="../../assets/images/ButtonFn.png"/></a>
                        <a><img src="../../assets/images/ButtonWl.png"/></a>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="launch_info_div" v-for="(obj, index) in launchList" :key="index">
                  <div class="launch_info_div01">
                    <img class="launch_info_div01_img" :src="imgHost + obj.images_group1[0]"/>
                    <div class="launch_info_div01_div"></div>
                  </div>

                  <div class="launch_info_div02">
                    <div class="launch_info_div022">
                      <div class="launch_info_div0221">
                        {{ obj.token_name }} <span>({{ obj.token_symbol }})</span>
                      </div>
                      <div class="launch_info_div0222" v-if="obj.project_id >= 0" @click="toMint(obj.project_id, obj.token_address)"> Mint </div>
                    </div>
                    <div class="launch_info_div023">
                      {{ obj.token_description }}
                    </div>
                  </div>

                  <div class="launch_info_div03">
                    <div class="launch_info_div031">
                      <div class="launch_info_div0311">
                        <img class="launch_info_div0311_divimg" src="../../assets/images/bnb_logo.png"/>
                        <div class="launch_info_div03111">
                          合约: <span @click="toLaunchLink(obj.token_address)">{{ cutAccount(obj.token_address, 5) }}</span> <img src="../../assets/images/copyl.png" @click="copyValue(obj.token_address)"/>
                        </div>
                      </div>

                      <div class="launch_info_div0312">
                        <img src="../../assets/images/biaoqian.png"/>
                        <div class="launch_info_div03121" v-if="obj.token_address" @click="toLaunchLink(obj.token_address)">
                          已发射至Pancake Swap
                        </div>
                        <div class="launch_info_div03121" v-else>
                          未发射至Pancake Swap
                        </div>
                      </div>
                    </div>
                    <div class="launch_info_div032">
                      <div class="launch_info_div0321">
                        <img src="../../assets/images/kx.png" @click="toKline(obj.token_address)"/>
                      </div>
                      <div class="launch_info_div0322">
                        <a v-show="obj.telegram"><img src="../../assets/images/ButtonTg.png" @click="toLink(obj.telegram)"/></a>
                        <a v-show="obj.twitter"><img src="../../assets/images/ButtonFn.png" @click="toLink(obj.twitter)"/></a>
                        <a v-show="obj.website"><img src="../../assets/images/ButtonWl.png" @click="toLink(obj.website)"/></a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="rwa_launch_page_02_0111_021_null" v-if="launchList.length === 0">
                {{ isLaunchListLoding ? 'Loading...' : '' }}
              </div>

              <div class="rwa_launch_page_02_0111_022">
                <el-pagination
                    :background="true"
                    @current-change="getLaunchList"
                    layout="prev, pager, next"
                    :page-size="limitNum"
                    :total="totalNum">
                </el-pagination>
              </div>
            </div>

            <div class="rwa_launch_page_02_0111_03">
              <div class="rwa_launch_page_02_0111_031">{{ lang('index11') }}</div>
              <div class="rwa_launch_page_02_0111_032">
                <img class="com" src="../../assets/images/List.png">

                <img class="mob" src="../../assets/images/logo_fxhao.png">
                <img class="mob" src="../../assets/images/logo_pancak.png">
                <img class="mob" src="../../assets/images/logo_ave.png">
                <img class="mob" src="../../assets/images/bin.png">
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="rwa_launch_page_03">
        <Bottom/>
      </div>
    </div>

  </div>
</template>

<script>
import {
  cutAccount,
  lang,
  BigNumber,
  BigNumberStr,
  BigNumberMul,
  BigNumberDiv,
  BigNumberAdd,
  BigNumberSub
} from '../../tools/index';

import transfer from "../../tools/transfer";
import Menu from "../../components/Menu";
import Bottom from "../../components/Bottom";
import * as metaMaskTools from "../../tools/chain";

import {
  debug,
  uploadHost
} from "@/config";
import { mixin1 } from "@/tools/mixins";
import toolUtils, { setDecimal, toTextDate } from "@/tools/toolUtils";

export default {
  name: "Index",
  components: { Menu, Bottom },
  mixins: [mixin1],
  data() {
    return {
      imgHost: uploadHost,
      pageNum: 1,
      limitNum: 10,
      totalNum: 1,
      bucoinLaunch: {
        projectId: -1,
        img: require('../../assets/images/image_yubi.png'),
        ca: '0x4e86BFa3376eC576053139d56779f983678f8ba8',
        tokenName: 'BUCOIN',
        tokenSymbol: 'bucoin',
        describe: '商代布币纹玉钺｜宫廷礼仪×原始货币符号孤品',
        link: 'https://ave.ai/token/0x4e86bfa3376ec576053139d56779f983678f8ba8-bsc?from=Home'
      },
      isLaunchListLoding: false,
      launchList: []
    };
  },
  created() {
    setTimeout(() => {
      this.onAccountsChanged();
    }, 1000);

    transfer.$on("initLaunchPageData", () => {
      this.initLaunchPageData();
    });
  },
  mounted() {
    this.initLaunchPageData();
  },
  watch: {
  },
  beforeDestroy() {
  },
  methods: {
    lang(key){
      return lang(key);
    },
    cutAccount(account, num) {
      return cutAccount(account, num);
    },
    setDecimal(num, numDecimalMax) {
      return setDecimal(num, numDecimalMax, false, false);
    },
    toTextDate(timestamp, isAll) {
      if (isAll) {
        return toTextDate(timestamp).substr(0, 16);
      } else {
        return toTextDate(timestamp).substr(5, 11);
      }
    },
    async onRefresh(accounts) {
      await this.$store.commit('setState', {
        accounts
      });

      await this.initLaunchPageData();
    },
    async initRefreshNetwork() {
      await metaMaskTools.initParams().then(() => {});
    },
    async initLaunchPageData() {
      await this.getLaunchList(1);
    },
    copyValue(val) {
      if (val) {
        toolUtils.copyValue(val);
        this.$message.success('Copy successful!');
      } else {
        this.$message.error('No content copied!');
      }
    },
    toKline(token) {
      if (token !== null && token !== undefined && token !== '') {
        this.$router.push({
          path: '/kline',
          query: {
            tokenAddress: token
          }
        });
      } else {
        this.$message.warning('No available K-line data!');
      }
    },
    toMint(id, token) {
      // this.$message.warning('Coming soon!');
      // return;

      if (id >= 0 && token !== null) {
        this.$router.push({
          path: '/mint',
          query: {
            projectId: id,
            tokenAddress: token
          }
        });
      } else {
        this.$message.warning('No mint!');
      }
    },
    toLink(link) {
      if (link) {
        window.open(link, "_blank");
      } else {
        this.$message.warning('Coming soon!');
      }
    },
    toLaunchLink(token) {
      if (token) {
        window.open('https://ave.ai/token/'+token+'-bsc?from=Home', "_blank");
      } else {
        this.$message.warning('Coming soon!');
      }
    },
    async getLaunchList(pageNum) {
      try {
        this.isLaunchListLoding = true;

        const page = pageNum > 0 ? this.pageNum = pageNum : this.pageNum = 1 ;
        const limit = this.limitNum;

        await this.$http.getProjectsLaunchedList(page, limit).then(res => {
          console.log("getProjectsLaunchedList: " + JSON.stringify(res));

          if (res.success) {
            this.launchList = res.data;
            this.totalNum = res.total;
          }

          this.isLaunchListLoding = false;
        }).catch(err => {
          this.$message.error(err);

          this.isLaunchListLoding = false;
        });
      } catch (e) {
        console.log(e);

        this.isLaunchListLoding = false;
      }
    }
  }
};
</script>

<style scoped lang="less">
.rwa_launch_div {
  width: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  .rwa_launch_page_01 {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
  .rwa_launch_page_02::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
  .rwa_launch_page_02 {
    overflow-y: auto;
    position: absolute;
    width: 100%;
    top: 84px;
    bottom: 0;
    background: #151515;
    .rwa_launch_page_02_01 {
      width: 100%;
      .rwa_launch_page_02_011 {
        position: relative;
        width: 100%;
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;
        align-items: flex-start;
        justify-content: flex-start;
        .rwa_launch_page_02_011_bj01 {
          position: absolute;
          top: 0;
          left: 0;
          z-index: 0;
          height: 100%;
          max-height: 880px;
          @media (max-width: 767px){
            max-height: 720px;
          }
        }
        .rwa_launch_page_02_011_bj03 {
          position: absolute;
          top: 0;
          right: 0;
          z-index: 0;
          max-width: 60%;
          @media (max-width: 767px){
            max-width: 45%;
            display: none;
          }
        }
        .rwa_launch_page_02_0111 {
          width: 80%;
          margin-left: 10%;
          display: flex;
          flex-direction: column;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: flex-start;
          z-index: 1;

          @media (max-width: 767px) {
            width: 90%;
            margin-left: 5%;
          }
          .rwa_launch_page_02_0111_01 {
            margin: 80px 0;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            justify-content: space-evenly;
            align-items: center;
            height: 256px;
            align-self: stretch;
            border-radius: 15px;
            background: #0A0A0A;
            color: white;

            @media (max-width: 767px) {
              margin: 20px 0 35px 0;
              flex-direction: column-reverse;
              justify-content: flex-end;
              height: auto;
              min-height: 535px;
              padding: 20px;
            }
            .index_page_bla_01 {
              max-width: 100%;
              .index_page_bla_011 {
                p {
                  color: #FFF;
                  font-family: Inter;
                  font-size: 28px;
                  font-style: normal;
                  font-weight: 700;
                  line-height: 10px; /* 85.714% */

                  @media (max-width: 767px) {
                    line-height: 40px;
                  }
                }
              }
              .index_page_bla_012 {
                color: #FFF;
                font-family: Inter;
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: 24px; /* 171.429% */
                margin: 20px 0;

                @media (max-width: 767px) {
                  font-size: 16px;
                }
              }
              .index_page_bla_013 {
                display: flex;
                flex-direction: row;
                flex-wrap: nowrap;
                justify-content: flex-start;
                align-items: center;
                .index_page_bla_0131 {
                  width: 110px;
                  display: flex;
                  padding: 8px 28px;
                  justify-content: center;
                  align-items: center;
                  gap: 10px;
                  border-radius: 8px;
                  background: #419552;
                  margin-right: 10px;
                  cursor: pointer;
                  @media (max-width: 767px) {
                    height: 43px;
                    zoom: 1.2;
                  }
                }
              }
            }
            .index_page_bla_02 {
              img {
                margin-top: 5px;

                @media (max-width: 767px) {
                  width: 100%;
                }
              }
            }
          }
          .rwa_launch_page_02_0111_02 {
            width: 100%;
            margin-bottom: 100px;
            .rwa_launch_page_02_0111_021 {
              display: flex;
              flex-direction: row;
              flex-wrap: wrap;
              align-content: flex-start;
              justify-content: flex-start;
              align-items: center;

              @media (max-width: 767px) {
                width: 100%;
                flex-direction: column;
                flex-wrap: nowrap;
                justify-content: flex-start;
                align-items: center;
              }
              .launch_info_div {
                @media (max-width: 767px) {
                  width: 100%;
                  height: 415px;
                }

                position: relative;
                display: flex;
                width: 240px;
                height: 280px;
                flex-direction: column;
                align-items: flex-end;
                border-radius: 16px;
                border: 1px solid rgba(153, 153, 153, 0.30);
                background: #313131;
                margin: 10px 10px 10px 10px;

                .launch_info_div01 {
                  position: absolute;
                  top: 0;
                  left: 0;

                  @media (max-width: 767px) {
                    width: 100%;
                  }
                  .launch_info_div01_img {
                    position: absolute;
                    top: 0;
                    left: 1px;
                    width: 238px;
                    height: 110px;
                    object-fit: cover;
                    border-top-left-radius: 16px;
                    border-top-right-radius: 16px;

                    @media (max-width: 767px) {
                      width: 100%;
                      height: 210px;
                    }
                  }
                  .launch_info_div01_div {
                    position: absolute;
                    top: 85px;
                    left: 0.3px;
                    display: flex;
                    width: 239px;
                    padding: 8px 0;
                    justify-content: flex-start;
                    align-items: center;
                    gap: 4px;
                    color: #FFF;
                    font-family: Roboto;
                    font-size: 16px;
                    font-style: normal;
                    font-weight: 700;
                    line-height: normal;
                    flex-direction: row;
                    flex-wrap: nowrap;

                    @media (max-width: 767px) {
                      top: 185px;
                    }
                  }
                }
                .launch_info_div02 {
                  position: absolute;
                  top: 115px;
                  left: 10px;
                  width: 218px;
                  height: auto;
                  color: #FFF;
                  line-height: normal;
                  border-bottom: 1px solid #666666;

                  @media (max-width: 767px) {
                    width: calc(100% - 20px);
                    top: 215px;
                  }
                  .launch_info_div022 {
                    display: flex;
                    flex-direction: row;
                    flex-wrap: nowrap;
                    justify-content: space-between;
                    align-items: center;
                    margin: 6px 0;
                    .launch_info_div0221 {
                      color: white;
                      font-family: "Plus Jakarta Sans";
                      font-size: 16px;
                      font-style: normal;
                      font-weight: 600;
                      line-height: 21px; /* 150% */
                      margin: 5px 0;

                      @media (max-width: 767px) {
                        font-size: 18px;
                        margin: 8px 0;
                      }
                      span {
                        font-size: 13px;

                        @media (max-width: 767px) {
                          font-size: 16px;
                        }
                      }
                    }
                    .launch_info_div0222 {
                      width: 58px;
                      font-size: 12px;
                      display: flex;
                      padding: 5px 8px;
                      justify-content: center;
                      align-items: center;
                      border-radius: 8px;
                      border: 1px solid #419552;
                      cursor: pointer;

                      @media (max-width: 767px) {
                        width: 68px;
                        font-size: 16px;
                        background: #419552;
                      }
                    }
                  }
                  .launch_info_div023 {
                    color: #c3c3c3;
                    font-family: "Plus Jakarta Sans";
                    font-size: 10px;
                    font-style: normal;
                    font-weight: 400;
                    min-height: 20px;
                    line-height: 20px;
                    margin-bottom: 5px;
                    display: -webkit-box;
                    -webkit-line-clamp: 2; /* 限制显示两行 */
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    text-overflow: ellipsis; /* 超出部分显示省略号 */

                    @media (max-width: 767px) {
                      font-size: 14px;
                      min-height: 25px;
                      line-height: 25px;
                    }
                  }
                }
                .launch_info_div03 {
                  position: absolute;
                  top: 205px;
                  left: 0;
                  width: 100%;
                  display: flex;
                  flex-direction: row;
                  flex-wrap: nowrap;
                  align-items: center;
                  justify-content: space-between;

                  @media (max-width: 767px) {
                    top: 270px;
                    zoom: 1.2;
                  }
                  .launch_info_div031 {
                    display: flex;
                    flex-direction: column;
                    flex-wrap: nowrap;
                    align-items: flex-start;
                    justify-content: flex-start;
                    height: 62px;
                    margin-top: 12px;
                    .launch_info_div0311 {
                      display: flex;
                      flex-direction: row;
                      flex-wrap: nowrap;
                      justify-content: flex-start;
                      align-items: center;
                      margin-bottom: 13px;

                      @media (max-width: 767px) {
                        margin-bottom: 15px;
                      }
                      .launch_info_div0311_divimg {
                        width: 15px;
                        margin: 0 2px 0 10px;
                      }
                      .launch_info_div03111 {
                        display: flex;
                        align-items: center;
                        flex-direction: row;
                        flex-wrap: nowrap;
                        justify-content: flex-start;

                        color: #20B26C;
                        font-family: Inter;
                        font-size: 10px;
                        font-style: normal;
                        font-weight: 700;
                        line-height: 13.5px; /* 135% */
                        //margin-top: 5px;

                        @media (max-width: 767px) {
                          font-size: 13px;
                        }
                        span {
                          text-decoration: underline;
                          cursor: pointer;
                        }
                        img {
                          width: 12px;
                          margin-left: 5px;
                          cursor: pointer;
                        }
                      }
                    }
                    .launch_info_div0312 {
                      display: flex;
                      flex-direction: row;
                      flex-wrap: nowrap;
                      align-items: center;
                      justify-content: flex-start;
                      img {
                        width: 12px;
                        margin: 0 5px 0 10px;
                      }
                      .launch_info_div03121 {
                        color: #20B26C;
                        font-family: Inter;
                        font-size: 10px;
                        font-style: normal;
                        font-weight: 500;
                        line-height: 13.5px; /* 150% */
                        cursor: pointer;

                        @media (max-width: 767px) {
                          font-size: 13px;
                        }
                      }
                    }
                  }
                  .launch_info_div032 {
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-start;
                    align-items: flex-end;
                    .launch_info_div0321 {
                      margin-right: 10px;
                      img {
                        width: 23px;
                        margin-top: -3px;
                        cursor: pointer;
                      }
                    }
                    .launch_info_div0322 {
                      display: flex;
                      flex-direction: row;
                      flex-wrap: nowrap;
                      align-items: center;
                      justify-content: flex-end;
                      margin-right: 6px;
                      a {
                        img {
                          width: 20px;
                          margin: 0 3px;
                          margin-top: 2px;
                          cursor: pointer;

                          @media (max-width: 767px) {
                            width: 25px;
                          }
                        }
                      }
                    }
                  }
                  .launch_info_div032_end {
                    background: #C69C6D !important;
                  }
                }
              }
            }
            .rwa_launch_page_02_0111_021_null {
              color: white;
              font-size: 26px;
              font-style: italic;
              font-weight: 900;
              text-align: center;
              margin-top: 30px;
              margin-bottom: 80px;
            }
            .rwa_launch_page_02_0111_022 {
              margin-top: 35px;
              @media (max-width: 767px) {
                zoom: 1.45;
              }
            }
          }
          .rwa_launch_page_02_0111_03 {
            .rwa_launch_page_02_0111_031 {
              color: #FFF;
              text-align: center;
              font-family: Inter;
              font-size: 24px;
              font-style: normal;
              font-weight: 400;
              line-height: normal;
            }
            .rwa_launch_page_02_0111_032 {
              text-align: center;
              display: flex;
              flex-direction: row;
              justify-content: center;

              @media (max-width: 767px) {
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                align-items: center;
                justify-content: space-around;
                align-content: flex-start;
                margin: 30px 0;
              }
              img {
                width: 60%;
                min-width: 680px;
                margin: 30px 0;

                @media (max-width: 767px) {
                  width: 30%;
                  min-width: 135px;
                  margin: 10px 0;
                }
              }
            }
          }
        }
      }
    }
    .rwa_launch_page_03 {
      width: 100%;
    }
  }
}
</style>

<style>
.rwa_launch_div {
  .el-pagination {
    text-align: center;
  }
  .el-pagination.is-background .el-pager li {
    background-color: #313131;
    color: #999999;
    border-radius: 5px !important;
  }
  .el-pagination.is-background .el-pager li:hover {
    color: #20B26C !important;
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #313131;
    border: 1.5px solid #20B26C;
    color: #20B26C;
  }
  .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li {
    background-color: #313131;
    color: #999999;
    border-radius: 5px !important;
  }

  .el-progress-bar {
    border-radius: 9px !important;
    border: 1px solid #20944B !important;
  }

  .el-progress-bar__inner {
    background: linear-gradient( 90deg, #0A2E17 0%, #20944B 100%) !important;
  }

  .el-form {
    margin: 0 20px !important;
  }

  .el-form-item__label {
    color: white !important;
  }

  .el-form-item__label:before {
    color: #6cf585 !important;
  }

  .el-textarea__inner {
    color: #c8cbd2 !important;
    background-color: transparent !important;
    border: 1px solid #61823a !important;
  }

  .el-cascader-node.in-active-path, .el-cascader-node.is-active, .el-cascader-node.is-selectable.in-checked-path {
    color: #1CFE5E !important;
  }

  .el-radio__input.is-checked .el-radio__inner {
    border-color: #1CFE5E !important;
    background: #1CFE5E !important;
  }

  .el-radio__input.is-checked+.el-radio__label {
    color: #1CFE5E !important;
  }

  .el-radio {
    color: #f6f6f6 !important;
  }

  .el-dialog__header {
    padding: 0 !important;
  }

  .el-cascader__dropdown {
    top: 35px !important;
  }

  /* 响应式文本颜色 */
  .responsive-text {
    color: #20944B;
  }

  @media (max-width: 1023px) {
    .responsive-text {
      color: #FFFFFF;
    }
  }
}
</style>
